import React from 'react';
import Icon from '../../Icon';
import clsx from 'clsx';
import { translate } from '../../../Services/translation';

const MobileNavigationItem = ({
  link,
  onLinkClick,
  isCurrentLink = false,
}: {
  link: any;
  onLinkClick: (link: any) => void;
  isCurrentLink?: boolean;
}) => {
  return (
    <>
      {(link.links?.length > 0 || link.extraInfo) && !isCurrentLink ? (
        <li
          onClick={() => onLinkClick(link)}
          className={clsx(
            'h4 flex cursor-pointer justify-between text-gray-700'
          )}
        >
          <span className="flex flex-1 items-center px-4 py-3">
            {link.name ?? link.columnHeading?.text}
          </span>

          <div className="flex cursor-pointer items-center p-4">
            <Icon
              className="gray-700 h-[1.5rem] w-[1.5rem]"
              name="chevron-right"
            />
          </div>
        </li>
      ) : (
        <li className={clsx('h4 flex justify-between text-gray-700')}>
          {link.url || link.columnHeading?.href ? (
            <a
              className="flex flex-1 items-center px-4 py-3"
              href={link.url ?? link.columnHeading?.href ?? ''}
            >
              {isCurrentLink
                ? `${translate('general.show-all')} ${link.name}`
                : link.name ?? link.columnHeading?.text}
            </a>
          ) : (
            <span className="flex flex-1 items-center px-4 py-3">
              {link.name ?? link.columnHeading?.text}
            </span>
          )}
        </li>
      )}
    </>
  );
};
export default MobileNavigationItem;
